import React, { Component } from "react";

export class ProfileNewsView extends Component {
  componentDidMount() {

  }
  render() {
    return (
      <div>
        <h1>Profile Page - News</h1>
      </div>
    );
  }
}
export default ProfileNewsView;
